import { useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { UserContext } from "../../providers/UserContext";
import { PostContext } from "../../providers/PostContext";
import { Loading } from "../../components/Loading/loading";

const ProtectedRoutes = () => {
  const { loading: userLoading, user } = useContext(UserContext),
    { loading } = useContext(PostContext);

  const navigate = useNavigate();

//   if (!user) {
//     navigate("/ultimas", { replace: true });
//   }

  if (userLoading) {
    return <Loading />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
